import React from 'react'
import ScrollContainer from 'src/legacy/components/ScrollContainer'
import { useIsAdmin, useIsCareCoordinator } from 'src/session'
import ABTestForm from 'src/legacy/components/ParticipantRecords/ParticipantRecord/ABTests/ABTestForm'
import { FullPatientFragment } from 'src/participant/patientQueries.generated'
import ParticipantHistory from '../../../participantHistory/ParticipantHistory'
import ParticipantRecordForm from './ParticipantRecord/ParticipantRecordForm'
import { IntegrationsForm } from './ParticipantRecord/integrations/IntegrationsForm'

type Props = {
  uid: string
  isLoading: boolean
  patient?: FullPatientFragment
}
const ParticipantRecords = ({ uid, isLoading, patient }: Props) => {
  const isAdmin = useIsAdmin()
  const isCareCoordinator = useIsCareCoordinator()

  return (
    <ScrollContainer>
      <ParticipantRecordForm uid={uid} isLoading={isLoading} patient={patient} />
      <ABTestForm uid={uid} isAdmin={isAdmin} />
      {(isAdmin || isCareCoordinator) && <IntegrationsForm uid={uid} junctionID={patient?.junctionID} />}
      <ParticipantHistory uid={uid} />
    </ScrollContainer>
  )
}

export default ParticipantRecords
